import script from "./DemandArticleGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandArticleGroup.vue?vue&type=script&setup=true&lang=ts"

import "./DemandArticleGroup.vue?vue&type=style&index=0&id=5d2681c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2681c0"]])

export default __exports__